import { useState } from "react";
import { Icon } from "../../icons";
import { BuzerIcon, CATEGORY_LABELS, ICON_CATEGORIES, ICON_LABEL } from "../../BuzerIcons";
import { st } from "../../styles.js";
import { api } from "../../lib/api";

export function IconPicker({ value, onPick, onAiSuggest, canAi = true, hideRequest = false }) {
  const [aiBusy, setAiBusy] = useState(false);
  return (
    <div>
      {onAiSuggest && (
        <button type="button" disabled={aiBusy || !canAi} style={{ ...st.aiBtn, marginBottom: 10, opacity: (aiBusy || !canAi) ? 0.6 : 1 }}
          onClick={async () => { setAiBusy(true); try { const ic = await onAiSuggest(); if (ic) onPick(ic); } catch (e) { /* */ } setAiBusy(false); }}>
          <BuzerIcon name="ai" size={14} /> {aiBusy ? "premýšľam…" : (canAi ? "Navrhni ikonu podľa údajov" : "Najprv napíš názov")}
        </button>
      )}
      <div style={st.iconPickScroll}>
      {Object.keys(CATEGORY_LABELS).filter((cat) => cat !== "ui").map((cat) => (
        <div key={cat} style={{ marginBottom: 10 }}>
          <div style={st.fieldHint}>{CATEGORY_LABELS[cat]}</div>
          <div style={st.iconPickGrid}>
            {(ICON_CATEGORIES[cat] || []).map((nm) => (
              <button type="button" key={nm} title={ICON_LABEL[nm]} onClick={() => onPick(nm)}
                style={{ ...st.iconPickBtn, ...(value === nm ? st.iconPickOn : {}) }}>
                <BuzerIcon name={nm} size={20} />
              </button>
            ))}
          </div>
        </div>
      ))}
      </div>
      {!hideRequest && <RequestIcon />}
    </div>
  );
}

// User can't find a fitting icon → request one in a word; it e-mails the owner via /api/contact.
export function RequestIcon() {
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  async function send() {
    const w = word.trim();
    if (!w) return;
    setBusy(true);
    try {
      await api("/api/contact", { method: "POST", body: { message: "Žiadosť o novú ikonu: „" + w + "“" } });
      setSent(true); setWord("");
    } catch (e) { /* keep input so they can retry */ }
    setBusy(false);
  }
  if (sent) return (
    <div style={{ ...st.infoNote, marginTop: 12, display: "flex", alignItems: "center", gap: 8 }}>
      <Icon name="check" size={16} color="var(--accent)" stroke={3} /> Ďakujeme! Poslali sme tvoj návrh ikony.
    </div>
  );
  return (
    <div style={{ marginTop: 14, borderTop: "1px solid var(--border)", paddingTop: 12 }}>
      <div style={st.fieldHint}>Chýba ti ikona? Napíš ju jedným slovom a pošleme ju tvorcovi.</div>
      <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
        <input className="field" value={word} maxLength={40} placeholder="napr. gitara, mačka, joga…"
          style={{ ...st.field, flex: 1 }} onChange={(e) => setWord(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); send(); } }} />
        <button type="button" onClick={send} disabled={busy || !word.trim()}
          style={{ ...st.primaryBtn, flex: "none", opacity: (busy || !word.trim()) ? 0.6 : 1 }}>
          {busy ? "…" : "Poslať"}</button>
      </div>
    </div>
  );
}
